export const promoCodeSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 54,
    backgroundColor: "rgba(255, 255, 255, 0.04)",
    borderColor: state.isFocused
      ? "rgba(0, 212, 245, 0.55)"
      : "rgba(255, 255, 255, 0.14)",
    borderRadius: 10,
    boxShadow: state.isFocused ? "0 0 0 3px rgba(0, 212, 245, 0.14)" : "none",
    "&:hover": {
      borderColor: state.isFocused
        ? "rgba(0, 212, 245, 0.55)"
        : "rgba(255, 255, 255, 0.22)",
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "#0e1730",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    borderRadius: 10,
    overflow: "hidden",
    zIndex: 20,
  }),
  menuList: (base) => ({
    ...base,
    padding: 6,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "rgba(0, 212, 245, 0.2)"
      : state.isFocused
        ? "rgba(255, 255, 255, 0.08)"
        : "transparent",
    color: "rgba(234, 240, 255, 0.9)",
    borderRadius: 8,
    cursor: "pointer",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    borderRadius: 8,
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "rgba(234, 240, 255, 0.92)",
    fontWeight: 600,
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "rgba(234, 240, 255, 0.6)",
    ":hover": {
      backgroundColor: "rgba(255, 77, 109, 0.3)",
      color: "#fff",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "rgba(234, 240, 255, 0.48)",
    fontWeight: 500,
  }),
  input: (base) => ({
    ...base,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "rgba(234, 240, 255, 0.5)",
    ":hover": {
      color: "#fff",
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "rgba(234, 240, 255, 0.5)",
    ":hover": {
      color: "#fff",
    },
  }),
};
